/* Audit fixes, 2026-09-05. Progressive enhancement only; the page is
     complete without this script. */
  (function () {
    /* Reduced motion for the thing the theme's own flag missed: Flickity
       autoplay is set from the section setting alone. The theme reads the
       flag once at load, so this listens for changes. The logo marquee is
       deliberately NOT paused here (Devon, 2026-09-25: the strip must keep
       moving); see the logo marquee block below. */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function calm() {
      if (!reduce.matches) return;
      if (window.Flickity && typeof Flickity.data === 'function') {
        Array.prototype.forEach.call(document.querySelectorAll('.flickity-enabled'), function (el) {
          var f = Flickity.data(el);
          if (f && typeof f.stopPlayer === 'function') f.stopPlayer();
        });
      }
    }
    function later() { setTimeout(calm, 400); }
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    if (reduce.addEventListener) reduce.addEventListener('change', calm); else if (reduce.addListener) reduce.addListener(calm);

    /* Logo marquee on touch devices. The theme runs one CSS loop over the
       whole bar in a fixed (33 - speed) seconds, so the more logos, the
       faster it goes. Pace it by width instead: 100px/s, halved under
       Reduce Motion (the CSS picks which). A tap pauses and resumes, which
       is the stop control a moving strip needs; desktop pauses on hover. */
    Array.prototype.forEach.call(document.querySelectorAll('logo-list'), function (el) {
      var bar = el.querySelector('.logo-bar');
      var w = bar ? bar.getBoundingClientRect().width : 0;
      if (w > 0) {
        el.style.setProperty('--se-duration', (w / 100).toFixed(1) + 's');
        el.style.setProperty('--se-duration-calm', (w / 50).toFixed(1) + 's');
      }
      el.addEventListener('click', function (e) {
        if (!document.documentElement.classList.contains('touch')) return;
        if (e.target.closest && e.target.closest('a')) return;
        el.classList.toggle('is-paused');
      });
    });

    /* Mobile dock: labels the nav landmark, which was the only unlabelled
       nav on the site. Until 2026-10-04 this also forced the dock up on
       phones; the theme now raises it only while the header is away
       (see section 10 of the CSS). */
    function dock() {
      var nav = document.querySelector('.mobile-dock-section nav.mobile-dock');
      if (nav && !nav.getAttribute('aria-label')) nav.setAttribute('aria-label', 'Quick links');
    }
    dock();
    document.addEventListener('DOMContentLoaded', dock);

    /* aria-controls pointing at the disabled age-verifier section, on
       every page. Lazily rendered drawers are left alone because their
       targets appear later and the reference then becomes valid. */
    Array.prototype.forEach.call(document.querySelectorAll('[aria-controls~="AgeVerifier"]'), function (el) {
      if (!document.getElementById('AgeVerifier')) el.removeAttribute('aria-controls');
    });

    /* Browse results had no list semantics: a custom element with div
       children, no headings, no count. */
    Array.prototype.forEach.call(document.querySelectorAll('motion-list.card-grid'), function (list) {
      list.setAttribute('role', 'list');
      var count = document.getElementById('ProductCount');
      list.setAttribute('aria-label', count ? count.textContent.replace(/\s+/g, ' ').trim() : 'Products');
      Array.prototype.forEach.call(list.children, function (c) { c.setAttribute('role', 'listitem'); });
    });

    /* Swatch labels announced as "BlackBlack": visible text plus an
       sr-only copy of the same text in one label. Hide the copy only
       when it duplicates visible text, so image-only swatches keep it. */
    Array.prototype.forEach.call(document.querySelectorAll('.swatches label'), function (l) {
      var sr = l.querySelector('.sr-only');
      if (!sr) return;
      var srText = sr.textContent.trim();
      var visible = l.textContent.replace(sr.textContent, '').replace(/\s+/g, ' ').trim();
      if (visible && visible === srText) sr.setAttribute('aria-hidden', 'true');
    });

    /* Home collection tiles: the image alt repeated the link text, so a
       screen reader heard each tile name twice. The link text carries
       the name; the image is decorative in that context. */
    Array.prototype.forEach.call(document.querySelectorAll('a.media-card__link img[alt]'), function (img) {
      var a = img.closest('a');
      if (!a) return;
      var t = a.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (t && img.alt.replace(/\s+/g, ' ').trim().toLowerCase() === t) img.alt = '';
    });

    /* Phone keyboard (2026-10-17). iPhone Safari keeps fixed bars on screen
       while the keyboard is open, so the bottom menu and the contact pill
       rode up and sat over the form just above it (Devon, on the contact
       page). While a text field has focus, or the visual viewport says a
       keyboard is up, html gets se-kb-open and audit-fixes.css section 25
       moves the menu, the pill and the chat button out of the way. They come
       back a beat after the field lets go, so stepping from one field to the
       next doesn't make them flicker. Phones and touch screens only.
       Pinch zoom also shrinks the visual viewport, so its scale is allowed
       for. If the keyboard closes while the field keeps focus (the Android
       back key does this) the bars come back. Focus inside Shopify Inbox's
       own panel is left alone: that panel covers the page anyway, and hiding
       the chat host would hide the box being typed in. */
    (function () {
      var root = document.documentElement;
      var touchOrPhone = window.matchMedia('(max-width: 767px), (pointer: coarse)');
      var vv = window.visualViewport;
      var NOT_TEXT = /^(checkbox|radio|range|button|submit|reset|image|file|color|hidden)$/;
      var timer = 0;
      var shrunk = false;
      var dismissed = false;

      function isTextEntry(el) {
        if (!el || el.nodeType !== 1) return false;
        if (el.isContentEditable) return true;
        if (el.disabled || el.readOnly) return false;
        var tag = el.tagName;
        if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
        return tag === 'INPUT' && !NOT_TEXT.test((el.getAttribute('type') || 'text').toLowerCase());
      }
      function viewportShrunk() {
        return !!vv && vv.height * (vv.scale || 1) < window.innerHeight * 0.75;
      }
      function update() {
        var active = document.activeElement;
        var inChat = !!(active && active.closest && active.closest('shopify-chat'));
        var focused = isTextEntry(active);
        var up = viewportShrunk();
        if (up) shrunk = true;
        else if (shrunk && focused) dismissed = true;
        root.classList.toggle('se-kb-open', touchOrPhone.matches && !inChat && (up || (focused && !dismissed)));
      }

      document.addEventListener('focusin', function (e) {
        clearTimeout(timer);
        if (isTextEntry(e.target)) { shrunk = false; dismissed = false; }
        update();
      });
      document.addEventListener('focusout', function () {
        clearTimeout(timer);
        timer = setTimeout(update, 150);
      });
      if (vv) vv.addEventListener('resize', update);
      if (touchOrPhone.addEventListener) touchOrPhone.addEventListener('change', update);
      window.addEventListener('pageshow', update);
      update();
    })();

    /* Bars the theme slides in at the bottom (2026-10-17): the sticky Add to
       cart card on product pages and "Filter and sort" on collection and
       search pages. Neither has a class to hook while it shows (the card is
       faded in from script, the filter bar rides with the end of the grid),
       so this reads whether each is docked at the bottom of the screen and
       where its top edge is: html.se-buybar-on / se-facetbar-on plus
       --se-buybar-lift / --se-facetbar-lift (top edge to the bottom of the
       screen). The chat button (site-interactions.css) and the contact pill
       (audit-fixes.css section 26) sit 12px above them instead of on top.
       Checked again once scrolling settles, because the bars are often
       still mid-slide when the last scroll event fires. */
    (function () {
      var root = document.documentElement;
      var bars = [
        { name: 'buybar', el: document.querySelector('.product-sticky-form__card') },
        { name: 'facetbar', el: document.querySelector('.facet-sticky .button') }
      ].filter(function (bar) { return bar.el; });
      if (!bars.length) return;
      var frame = 0;
      var settle = 0;
      function check() {
        frame = 0;
        var h = window.innerHeight;
        bars.forEach(function (bar) {
          var cs = window.getComputedStyle(bar.el);
          var r = bar.el.getBoundingClientRect();
          // On screen AND docked in the bottom strip: the filter bar also passes
          // through mid-screen at the end of the grid, where nothing needs lifting.
          var on = cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.5 &&
            r.height > 0 && r.top < h && r.bottom >= h - 160;
          if (on) root.style.setProperty('--se-' + bar.name + '-lift', Math.max(0, Math.round(h - r.top)) + 'px');
          root.classList.toggle('se-' + bar.name + '-on', on);
        });
      }
      function soon() {
        if (!frame) frame = requestAnimationFrame(check);
        clearTimeout(settle);
        settle = setTimeout(check, 600);
      }
      window.addEventListener('scroll', soon, { passive: true });
      window.addEventListener('resize', soon);
      document.addEventListener('transitionend', soon, true);
      soon();
    })();

    /* Live chat joins the footer's social row (2026-10-18). Devon: "i want
       the button to live next to the social media buttons when it gets to
       the bottom and not below the legal copy". Once Shopify Inbox has
       loaded, a "Live chat" pill goes in after the social circles. As the
       pill slides up level with the floating button (read from where that
       button really is, so the menu, the filter bar and the Add to cart card
       are all allowed for), html gets se-chat-docked and
       site-interactions.css fades the floating button out: it settles into
       the row, only one is ever on screen and the legal line is never under
       it. Scroll back up and it returns. The pill presses the app's own
       button, which still works while hidden, and takes focus back when the
       chat closes, because the app returns focus to its own hidden button. */
    (function () {
      var socials = document.querySelector('.footer__socials');
      if (!socials) return;
      var root = document.documentElement;
      var WAVE = '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M6.69197 7.4636L4.78685 4.16382C4.55823 3.76785 4.69635 3.25961 5.09003 3.03232C5.48371 2.80503 5.99292 2.93953 6.22153 3.33551L8.12666 6.63528"/>' +
        '<path d="M5.25744 8.29198L3.60081 5.42261C3.3722 5.02664 3.51032 4.5184 3.904 4.29111C4.29767 4.06382 4.80688 4.19832 5.0355 4.5943L6.69213 7.46366"/>' +
        '<path d="M7.94451 6.31946L6.43373 3.70272C6.22524 3.34161 6.3797 2.86166 6.77338 2.63437C7.16706 2.40708 7.65993 2.51329 7.86842 2.8744L10.5283 7.48144"/>' +
        '<path d="M10.5441 7.50858L10.8125 5.63043C10.8771 5.17767 11.2994 4.86346 11.7498 4.92787C12.2002 4.99227 12.4711 5.3768 12.4523 5.86511L12.2885 8.9622C12.2411 9.85807 11.7438 10.6693 10.9668 11.1179L8.76882 12.3869C7.50114 13.1188 5.87992 12.6844 5.14802 11.4167L2.41425 6.68168C2.18563 6.2857 2.32376 5.77747 2.71743 5.55018C3.11111 5.32289 3.62032 5.45739 3.84893 5.85336L5.25707 8.29232"/>' +
        '<path d="M4.16667 14.4967C2.69378 14.4967 1.5 13.303 1.5 11.8301"/>' +
        '<path d="M11.8299 1.49984C13.3028 1.49984 14.4966 2.69362 14.4966 4.1665"/></svg>';
      var pill = null;
      var frame = 0;
      var settle = 0;
      var tries = 0;
      var fromPill = false;

      function chatButton() {
        var host = document.querySelector('shopify-chat');
        var shadow = host && host.shadowRoot;
        if (!shadow) return null;
        var runtime = shadow.querySelector('shopify-agent-runtime');
        return shadow.querySelector('button.activator') ||
          (runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('button.activator')) || null;
      }
      // Docked while the pill is on screen and level with or above the
      // floating button. Its box keeps its place while faded, so this reads
      // the same either side of the swap. While the chat window is open the
      // app hides its button (no box), which leaves things undocked.
      // Also kept off the hero (Devon, 2026-10-18: "the chat button is
      // covering here, should only appear once we [are] below the fold"):
      // while a hero (the section around a .banner__box, the box the
      // contact pill steps aside for) still shares the button's height on
      // screen, html gets se-chat-hero; the button waits until the hero has
      // scrolled past, then pings in.
      function check() {
        frame = 0;
        var button = chatButton();
        if (!button) return;
        var p = pill.getBoundingClientRect();
        var b = button.getBoundingClientRect();
        root.classList.toggle('se-chat-docked', p.height > 0 && b.height > 0 && p.bottom > 0 && p.top < b.bottom);
        var overHero = b.height > 0 && Array.prototype.some.call(document.querySelectorAll('.banner__box'), function (box) {
          var h = (box.closest('.shopify-section') || box).getBoundingClientRect();
          return h.height > 0 && h.bottom > b.top && h.top < b.bottom;
        });
        root.classList.toggle('se-chat-hero', overHero);
      }
      function soon() {
        if (!frame) frame = requestAnimationFrame(check);
        clearTimeout(settle);
        settle = setTimeout(check, 450);
      }
      function build() {
        var host = document.querySelector('shopify-chat');
        pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'se-footer-chat';
        pill.innerHTML = WAVE + '<span>Live chat</span>';
        pill.addEventListener('click', function () {
          var button = chatButton();
          if (!button) return;
          fromPill = true;
          button.click();
        });
        socials.appendChild(pill);
        window.addEventListener('scroll', soon, { passive: true });
        window.addEventListener('resize', soon);
        new MutationObserver(function () {
          check();
          if (fromPill && !host.hasAttribute('open')) {
            fromPill = false;
            if (root.classList.contains('se-chat-docked')) pill.focus();
          }
        }).observe(host, { attributes: true, attributeFilter: ['open'] });
        soon();
      }
      // Inbox can load late (it waits for the page to settle), so keep
      // looking for a few minutes, quickly at first.
      (function wait() {
        if (chatButton()) build();
        else if (++tries < 150) setTimeout(wait, tries < 20 ? 500 : 2000);
      })();
    })();

    /* Footer social row (2026-10-18). Devon: "the social media icons feel
       left heavy, can we maybe add more icons like directions?", then "we
       either add one such as email" and "the icons are to far spaced, can
       we add another icon". WhatsApp, Call, Email and Directions join
       Facebook, Instagram, YouTube and LinkedIn in the same circles, and
       site-interactions.css spreads the eight edge to edge under Live chat.
       Their addresses are read from the page (the contact pill's WhatsApp
       link, the footer's shop number and email address, and "Get
       directions" in Visit the shop), so they always match those; any is
       skipped if its link isn't there. The contact pill steps aside at the
       footer, so these keep WhatsApp, a call and email a tap away there. */
    (function () {
      var list = document.querySelector('.footer__socials ul');
      if (!list) return;
      var wa = document.querySelector('.contact-dock a[href*="wa.me"]');
      var maps = Array.prototype.filter.call(document.querySelectorAll('.footer a[href*="maps"]'), function (a) {
        return /directions/i.test(a.textContent);
      })[0] || document.querySelector('.footer a[href*="maps"]');
      var tel = document.querySelector('.footer a[href^="tel:"]');
      var mail = document.querySelector('.footer a[href^="mailto:"]');
      var PATHS = {
        whatsapp: 'M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.05 21.79h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.88 9.88zm8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.31-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.17-3.48-8.41z',
        call: 'M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z',
        email: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z',
        directions: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z'
      };
      function add(href, label, path, sameTab) {
        if (!href) return;
        var li = document.createElement('li');
        var a = window.customElements && customElements.get('magnet-link') ?
          document.createElement('a', { is: 'magnet-link' }) : document.createElement('a');
        a.href = href;
        if (!sameTab) {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
          if (document.getElementById('a11y-new-window-message')) a.setAttribute('aria-describedby', 'a11y-new-window-message');
        }
        a.className = 'social_platform block relative';
        a.setAttribute('aria-label', label);
        a.innerHTML = '<svg class="icon icon-lg" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="' + path + '"/></svg>';
        li.appendChild(a);
        list.appendChild(li);
      }
      add(wa && wa.href, 'Scuba Evolution on WhatsApp', PATHS.whatsapp);
      add(tel && tel.getAttribute('href'), 'Call the shop', PATHS.call, true);
      add(mail && mail.getAttribute('href'), 'Email the shop', PATHS.email, true);
      add(maps && maps.href, 'Directions to the shop', PATHS.directions);
      // One grid column per circle, so the row always runs edge to edge.
      list.parentNode.style.setProperty('--se-social-n', list.children.length);
    })();

    /* Footer menus on phones (2026-10-18). Devon: "can we have explore open
       and the other two closed for a person to expand. if something expands
       the previous must close and that expansion must come into view". The
       theme opens every block marked "open by default" (all three are), so
       on phones this closes all but the first straight after, without the
       slide. Opening one closes the others with the theme's own slide; once
       both slides are done, the one just opened scrolls into view if any of
       it is off screen, clear of the header and the bottom menu. From
       768px up the columns are always open and none of this runs. The
       theme re-opens them on its matchSmall event, so that is re-applied. */
    (function () {
      var wrap = document.querySelector('.footer__accordions');
      if (!wrap) return;
      var items = Array.prototype.filter.call(wrap.children, function (el) { return el.tagName === 'DETAILS'; });
      if (items.length < 2) return;
      var small = window.matchMedia('(max-width: 767px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var timer = 0;

      // The theme's own setter keeps its state right; finishing the
      // animations it has just started skips the slide.
      function shutNow(d) {
        if (!d.open) return;
        d.open = false;
        [d, d.querySelector('.details__content')].forEach(function (el) {
          if (el && el.getAnimations) el.getAnimations().forEach(function (a) { a.finish(); });
        });
      }
      function settle() {
        if (!small.matches) return;
        items.forEach(function (d, i) { if (i > 0) shutNow(d); });
      }
      function reveal(d) {
        var vh = window.innerHeight;
        var r = d.getBoundingClientRect();
        var header = document.querySelector('.header-section .header');
        var headerH = header ? header.getBoundingClientRect().height : 0;
        var dock = document.querySelector('.mobile-dock');
        var dockR = dock ? dock.getBoundingClientRect() : null;
        var floor = vh - (dockR && dockR.top < vh - 2 ? dockR.height : 0) - 12;
        if (r.top >= headerH + 12 && r.bottom <= floor) return;
        // Scrolling up brings the header back over the top, so allow for it.
        var delta = r.top - 12;
        if (delta < 0) delta -= headerH;
        window.scrollTo({ top: window.scrollY + delta, behavior: reduce.matches ? 'auto' : 'smooth' });
      }

      wrap.addEventListener('toggle', function (e) {
        if (!small.matches || !e.detail || !e.detail.open) return;
        var opened = e.detail.current;
        items.forEach(function (d) { if (d !== opened && d.open) d.open = false; });
        clearTimeout(timer);
        timer = setTimeout(function () { reveal(opened); }, 420);
      });
      document.addEventListener('matchSmall', settle);
      settle();
    })();

    /* Shopify's own policy pages, /policies/refund-policy and the rest (2026-10-19). They
       stay, because checkout and order emails link to them, but the site now reads every
       policy on /pages/policies, in the FAQ page's layout. So each of these pages gets the
       site's breadcrumb (Home / Policies / Refund policy) above its title and a link under
       the text that opens the same policy there, and nobody is left on a page with no way
       back. The policy page markup is Shopify's, not the theme's, hence the script. */
    (function () {
      var box = document.querySelector('.shopify-policy__container');
      if (!box || box.querySelector('.se-policy-crumbs')) return;
      var title = box.querySelector('.shopify-policy__title h1');
      var name = title ? title.textContent.trim() : '';
      var handle = (window.location.pathname.split('/policies/')[1] || '').split(/[/?#]/)[0];
      var all = '/pages/policies' + (handle ? '#' + handle : '');

      var nav = document.createElement('nav');
      nav.className = 'se-policy-crumbs';
      nav.setAttribute('aria-label', 'Breadcrumb');
      var ol = document.createElement('ol');
      [['Home', '/'], ['Policies', '/pages/policies'], [name, '']].forEach(function (c) {
        if (!c[0]) return;
        var li = document.createElement('li');
        var el = document.createElement(c[1] ? 'a' : 'span');
        el.textContent = c[0];
        if (c[1]) el.href = c[1]; else el.setAttribute('aria-current', 'page');
        li.appendChild(el);
        ol.appendChild(li);
      });
      nav.appendChild(ol);
      box.insertBefore(nav, box.firstChild);

      var foot = document.createElement('p');
      foot.className = 'se-policy-all';
      var a = document.createElement('a');
      a.href = all;
      a.textContent = 'See all our policies in one place';
      foot.appendChild(a);
      box.appendChild(foot);
    })();

    /* Links to Shopify's policy pages (2026-10-19): the delivery link in the announcement
       bar, the privacy link in the cookie banner, refund links in FAQ answers and product
       pages, the cross references inside the policies and the Terms of Use page. They are
       written in many places, some of them shop content rather than theme, so they are
       pointed here, once, at /pages/policies#refund-policy and the rest: the visitor stays
       in the site's own look. Only this site's six policies are touched (not, say,
       hCaptcha's), and only while the footer links to the Policies page, so they can never
       be sent to a page that is not there. Checkout is Shopify's and keeps its own links. */
    (function () {
      if (!document.querySelector('.footer-copyright a[href$="/pages/policies"]')) return;
      var known = /^(refund-policy|shipping-policy|terms-of-service|privacy-policy|legal-notice|contact-information)\/?$/;
      Array.prototype.forEach.call(document.querySelectorAll('a[href*="/policies/"]'), function (a) {
        var u;
        try { u = new URL(a.getAttribute('href'), window.location.href); } catch (e) { return; }
        if (u.host !== window.location.host || u.pathname.indexOf('/policies/') !== 0) return;
        var handle = u.pathname.slice(10);
        if (!known.test(handle)) return;
        a.setAttribute('href', '/pages/policies#' + handle.replace(/\/$/, ''));
      });
    })();

    /* The pill and the chat step aside from forms (2026-10-23, audit 4.2):
       audit-fixes-2.css section 35. On screens under 1024px, while a buy
       form, a size or colour row, or the cart's footer sits in the bottom
       150px of the screen, html gets se-form-near and the contact pill and
       the chat button get out of the way of it. Read on scroll and resize,
       settled once scrolling stops, the same way as the bars above. */
    (function () {
      var root = document.documentElement;
      var narrow = window.matchMedia('(max-width: 1023px)');
      var sel = '.product-form__buttons, .buy-buttons, .product-form__input, .variant-picker, .cart__sidebar, .totals, .cart-items, .cart-item, #mbar, .sgb-bar';
      var frame = 0, settle = 0;
      function check() {
        frame = 0;
        var near = false;
        if (narrow.matches) {
          var h = window.innerHeight;
          var els = document.querySelectorAll(sel);
          for (var i = 0; i < els.length && !near; i++) {
            var cs = window.getComputedStyle(els[i]);
            if (cs.display === 'none' || cs.visibility === 'hidden') continue;
            var r = els[i].getBoundingClientRect();
            if (r.height > 0 && r.bottom > h - 150 && r.top < h) near = true;
          }
        }
        root.classList.toggle('se-form-near', near);
      }
      function soon() {
        if (!frame) frame = requestAnimationFrame(check);
        clearTimeout(settle);
        settle = setTimeout(check, 500);
      }
      window.addEventListener('scroll', soon, { passive: true });
      window.addEventListener('resize', soon);
      document.addEventListener('cart:refresh', soon);
      document.addEventListener('variant:change', soon);
      soon();
      setTimeout(check, 2500);
    })();

    /* Store landings on phones (2026-10-23, critique 6.5): audit-fixes-2.css
       section 34 shows the first three lines of the page's intro paragraph;
       this adds the "Read more" that opens the rest. Only where the page has
       the store tile grid, only when the paragraph is actually clipped. */
    (function () {
      if (!document.querySelector('.store-cards')) return;
      var phone = window.matchMedia('(max-width: 767px)');
      var paras = document.querySelectorAll('#MainContent .page.rte > p');
      if (!paras.length) return;
      var p = paras[0];
      p.classList.add('se-clamp');
      function arm() {
        if (!phone.matches || p.classList.contains('is-open')) return;
        if (p.scrollHeight <= p.clientHeight + 2) { p.classList.remove('se-clamp'); return; }
        if (p.nextElementSibling && p.nextElementSibling.classList.contains('se-more')) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'se-more';
        b.textContent = 'Read more';
        b.setAttribute('aria-expanded', 'false');
        b.addEventListener('click', function () {
          p.classList.add('is-open');
          b.remove();
        });
        p.insertAdjacentElement('afterend', b);
      }
      arm();
      window.addEventListener('resize', arm);
    })();

  })();
